import { render } from "./ribbons2.vue?vue&type=template&id=bbcba024"
import script from "./ribbons2.vue?vue&type=script&lang=js"
export * from "./ribbons2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__